<template>
  <div>
    <b-overlay :show="loading"  :opacity="0.65" rounded="sm" class="mx-md-5">
      <div class="card mt-3 mb-3 bg-form">
        <card-header
          :title="$t('reports.title')"
          :iconName="'journal-text'"
        />
        <b-card-body>

          <reports-filters v-if="this.userInfo != null && this.selectedUnitId != null && this.usersAccessibleUnits != null" :filters="this.filters" :criteria="this.params" :selectedUnitId="this.selectedUnitId"
                          @criteria-changed="criteriaChanged" v-on:error:api.capture="handleError"/>

          <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
          <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
            {{ error.message }}
          </b-alert>
          <b-skeleton-wrapper :loading="loading">
            <template #loading>
              <reports-table-skeleton />
            </template>
            <template v-if="this.reportsList != null && this.usersAccessibleUnits != null">
              <report-table :reportsList="this.reportsList" :fields="this.fields" :usersAccessibleUnits="this.usersAccessibleUnits" :sortBy="sortBy" :sortDesc="sortDesc"
                v-on:error:api.capture="handleError"  @download-report="downloadReport" @pagination-changed='paginationChanged' @sorting-changed='shortingChanged' :item-count="itemCount"/>
            </template>
          </b-skeleton-wrapper>
        </b-card-body>
      </div>
    </b-overlay>
  </div>
</template>


<script>
import cardHeader from '../../components/common/cardHeader.vue';
import memberService from '../../services/member.service';
import { handleApiError } from '../../services/error.service';
import ReportTable from '../../components/reports/reportsTable.vue';
import ReportsFilters from '../../components/reports/reportsFilters.vue';
import ReportsTableSkeleton from '../../components/reports/reportsTableSkeleton.vue';
export default {
  components: { ReportTable, cardHeader, ReportsFilters, ReportsTableSkeleton },
  data() {
    return {
      popSuccessAlert: false,
      successMessage: null,
      popAlert: false,
      itemCount: 25,
      errors: [],
      filters: {
        // unit: true,
      },
      params: {
        unitId: null,
      },
      fields: [
        { key: "user.id", label: "Α.Μ.", sortable: true },
        { key: "user.orgMember.surName", label: "Επώνυμο", sortable: true},
        { key: "user.orgMember.firstName", label: "Όνομα", sortable: false},
        { key: "user.username", label: "Username", sortable: false},
        { key: "role.name", label: "Ρόλος", sortable: false, formatter: "translateRole"},
        { key: "unit.name", label: "Κλιμάκιο", sortable: true},
      ],
      sortBy: "surName",
      sortDesc: false,
      reportsList: null,
      userInfo: null,
      usersAccessibleUnits: null,
      selectedUnitId: null,
      loading: false
    }
  },
  mounted() {
    memberService.getUserInfo(this.username).then(
      (response) => {
        this.$store.state.userInfo = response.data;
        this.userInfo = response.data;
        this.$log.debug(this.userInfo)
        this.selectedUnitId = this.userInfo.orgMember.orgUnit.id;
        this.params.unitId = this.selectedUnitId;
        this.$log.debug(this.params)
        this.getReportsByCriteria(this.params);
        this.fetchAccessibleUnits();
        
      },
      (error) => {
        this.handleError(handleApiError(error));
      }
    );
  },
   methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchAccessibleUnits(){
      memberService.getAccessibleUnits(this.username).then(
          (response) => {
            this.usersAccessibleUnits = response.data.VIEW_UNIT;
            this.$store.state.usersAccessibleUnits = this.usersAccessibleUnits;
            // this.$log.debug(`Accessible units: ${this.usersAccessibleUnits}`);
          },
          (error) => {
            this.handleError(handleApiError(error));
          }
      );
    },
    getReportsByCriteria(params) {
      this.reportsList= null;
      this.loading = true;
      if(this.params.limit == null){
        this.params.limit = 10;
      }
      if( this.params.pageNo == null) {
        this.params.pageNo = 0;
      }
      memberService.getReport("users", params).then(
          (response) => {
            this.$log.debug(response.data)
            this.reportsList = response.data;
            this.itemCount = parseInt(response.headers.itemtotal);
            this.loading = false;
          },
          (error) => {
            this.handleError(handleApiError(error));
            this.loading = false;
          }
      );
    },
     downloadReport(){
       this.loading = true;
      const fileDownload = require('js-file-download');
       memberService.downloadReportExcel("users", this.params)
           .then(response => {
                 fileDownload(response.data, 'users.xls');
                 this.loading = false;
               },
               (error) => {
                 this.handleError(handleApiError(error));
                 this.loading = false;
               }
           )
     },
    criteriaChanged(criteria) {
      this.$log.debug(criteria)
      this.selectedUnitId = criteria.unitId;
      this.params = criteria;
      this.reportsList = null;
      this.getReportsByCriteria(criteria); 
    },
     paginationChanged(pagination) {
       this.params.limit = pagination.perPage;
       this.params.pageNo = pagination.currentPage - 1;
       this.getReportsByCriteria(this.params);
     },
     shortingChanged(sorting) {
       this.params.orderby = sorting;
       this.getReportsByCriteria(this.params);
     }
  }
}
</script>